export class ErrorResult {
    public Status: string;
    public Message: string;
}


// WEBPACK FOOTER //
// ./src/entities/errorResult.ts